import type { StatusTier } from "@/components/ui/badge"

export type EnquirySource = "web_form" | "phone" | "email" | "lead_import"
export type EnquiryStatus = "new" | "contacted" | "closed"

export interface EnquirySummary {
  id: number
  name: string | null
  email: string | null
  phone: string | null
  school_name_as_typed: string | null
  state: string | null
  matched_school: {
    id: number
    name: string | null
    has_history: boolean
  } | null
  match_confidence: string | null
  source: EnquirySource
  status: EnquiryStatus
  received_at: string
  age_hours: number
  sla_breached: boolean
  first_response_at: string | null
  closed_reason: string | null
  closed_at: string | null
}

export interface EnquiryDetail extends EnquirySummary {
  year_level_interest: string | null
  program_interest: string | null
  consent_programs_comms: boolean
  imported_lead_id: string | null
}

export interface MatchCandidate {
  salesforce_account_id: string
  name: string | null
  confidence: string
  has_history: boolean
}

export const STATUS_COLOR: Record<EnquiryStatus, StatusTier> = {
  new: "caution",
  contacted: "remote",
  closed: "system",
}
